import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Chip,
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  Tooltip,
  Typography,
  Alert,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import {
  deleteLocatorHistoryFileAsync,
  loadLocatorFileAsync,
  loadLocatorHistoryAsync,
  selectActiveHistoryFile,
  selectHistoryError,
  selectHistoryFiles,
  selectHistoryLoading,
  setActiveTab,
} from '../../../redux/locatorDrift/locatorDriftSlice';
import EmptyState from '../shared/EmptyState';
import { historyStyles } from './historyStyles';

export default function HistoryTab() {
  const dispatch = useDispatch();
  const historyFiles = useSelector(selectHistoryFiles);
  const historyLoading = useSelector(selectHistoryLoading);
  const historyError = useSelector(selectHistoryError);
  const activeHistoryFile = useSelector(selectActiveHistoryFile);

  useEffect(() => {
    if (historyFiles.length === 0) {
      dispatch(loadLocatorHistoryAsync());
    }
  }, [dispatch, historyFiles.length]);

  if (historyLoading) return <CircularProgress sx={historyStyles.loader} />;
  if (historyError) return <Alert severity="error">{historyError}</Alert>;
  if (historyFiles.length === 0) {
    return <EmptyState>No locator run history found.</EmptyState>;
  }

  return (
    <Stack spacing={2}>
      <Box sx={historyStyles.metaRow}>
        {historyFiles.map((file) => {
          const active = file.filename === activeHistoryFile;
          const passed = file.test_passed;
          const badgeText = passed
            ? 'PASSED'
            : file.real_fails > 0
              ? `${file.real_fails} FAILED`
              : 'FAILED';
          return (
            <Paper
              key={file.run_id}
              variant="outlined"
              onClick={() => {
                dispatch(setActiveTab('results'));
                dispatch(loadLocatorFileAsync(file.run_id));
              }}
              sx={historyStyles.item(active)}
            >
              <Box sx={historyStyles.itemContent}>
                <Typography variant="body2" fontWeight={700} noWrap>
                  {file.scenario || file.filename}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {file.app_version || 'Unknown app'} - {file.collected_at?.substring(0, 16) || ''}
                </Typography>
              </Box>
              <Chip size="small" color={passed ? 'success' : 'error'} label={badgeText} />
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  onClick={(event) => {
                    event.stopPropagation();
                    dispatch(deleteLocatorHistoryFileAsync(file.filename));
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Paper>
          );
        })}
      </Box>
    </Stack>
  );
}
